import { AddBookVerAPI, GetHaveBookVerAPI } from '@/api/bookver'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 设置教材版本的数据
    async addbookver({ commit }, item) {
      await AddBookVerAPI(item)
    },
    // 获取教材版本进行回显
    async gethavebookver() {
      const res = await GetHaveBookVerAPI()
      return res
    }
  }
}
